import { FILE_SIZE_LIMIT } from "./constants";


export function validateFilesSize(files: File[]): string[] {
    const MAX_SIZE_BYTES = FILE_SIZE_LIMIT;
    const errors: string[] = [];

    files.forEach((file, index) => {
        if (file.size > MAX_SIZE_BYTES) {
            errors.push(`File "${file.name}" exceeds the 5MB limit.`);
        }
    });

    return errors;
}